// Shared constants for the Materials catalog UI.
// Kept in a non-component module so fast-refresh works for the components that import it.

// Maps to MaterialUnitType.choices on the backend
export const MATERIAL_UNIT_TYPES = [
  { value: 'area', label: 'Area (squares, sq ft)' },
  { value: 'linear', label: 'Linear (feet, meters)' },
  { value: 'volume', label: 'Volume (gallons, liters)' },
  { value: 'weight', label: 'Weight (pounds, kg)' },
  { value: 'count', label: 'Count (pieces, units)' },
];
